export enum ProgramStatus {
  ACTIVE = 1,
  ARCHIVE = 2
}

export enum ProgramStatusText {
  ACTIVE = 'Активная',
  ARCHIVE = 'Архивная'
}
